<template>
  <div>
  <!--<sound-wave class="absolute w-full top-28 lg:top-0 z-0 opacity-75"></sound-wave>-->
    <div class="relative h-full z-10 my-20">
      <div class="flex flex-col text-2xl lg:text-4xl justify-center pt-20 pb-2 mb-10
            text-white font-medium border-b border-white items-center uppercase
            md:normal-case w-11/12 lg:w-auto mx-auto lg:mx-32">
              Masterclasses
      </div>
      <div class="flex flex-wrap flex-col md:flex-row">
        <masterclass-card v-for="masterclass in masterclasses"
        :key="masterclass.id" :masterclass="masterclass"
        class="w-3/4 mx-auto mb-20 z-10" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import MasterclassCard from '../components/masterclasses/MasterclassCard.vue';
// import SoundWave from '../components/graphics/SoundWave.vue';

export default {
  components: {
    MasterclassCard,
  },

  data() {
    return {
      masterclasses: [],
    };
  },

  created() {
    this.getMasterclasses();
  },

  methods: {
    getMasterclasses() {
      axios.get('/api/masterclasses').then(({ data }) => {
        this.masterclasses = data;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },
  },
};
</script>
